module.exports = __webpack_public_path__ + "img/of.d78d28ac.svg";